// removed by extract-text-webpack-plugin
module.exports = {"App":"App__App--3Ge-C"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 47
// module chunks = 0